import {
  YJCS_CONTRACT_GET_LIST,
  YJCS_CONTRACT_GET_LIST_SUCCESS,
  YJCS_CONTRACT_GET_LIST_ERROR,
  YJCS_CONTRACT_GET_BY_ID,
  YJCS_CONTRACT_GET_BY_ID_SUCCESS,
  YJCS_CONTRACT_GET_BY_ID_ERROR,
  YJCS_CONTRACT_ADD_ITEM,
  YJCS_CONTRACT_ADD_ITEM_SUCCESS,
  YJCS_CONTRACT_ADD_ITEM_ERROR,
  YJCS_CONTRACT_EDIT_ITEM,
  YJCS_CONTRACT_EDIT_ITEM_SUCCESS,
  YJCS_CONTRACT_EDIT_ITEM_ERROR,
  YJCS_CONTRACT_DELETE_ITEM,
  YJCS_CONTRACT_DELETE_ITEM_SUCCESS,
  YJCS_CONTRACT_DELETE_ITEM_ERROR,
  YJCS_CONTRACT_GET_BY_EMPLOYER,
  YJCS_CONTRACT_GET_BY_EMPLOYER_SUCCESS,
  YJCS_CONTRACT_GET_BY_EMPLOYER_ERROR,
  YJCS_CONTRACT_GET_BY_CLIENT,
  YJCS_CONTRACT_GET_BY_CLIENT_SUCCESS,
  YJCS_CONTRACT_GET_BY_CLIENT_ERROR,
} from '../actions';

//yjcsContracts
const initialState = {
  yjcsContracts: [],
  yjcsContract: null,
  error: '',
  loading: false,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function reducerState(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case YJCS_CONTRACT_GET_BY_ID:
    case YJCS_CONTRACT_GET_LIST:
    case YJCS_CONTRACT_GET_BY_EMPLOYER:
    case YJCS_CONTRACT_GET_BY_CLIENT:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case YJCS_CONTRACT_GET_LIST_SUCCESS:
    case YJCS_CONTRACT_GET_BY_EMPLOYER_SUCCESS:
    case YJCS_CONTRACT_GET_BY_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        yjcsContracts: payload,
      };

    case YJCS_CONTRACT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        yjcsContract: payload,
      };

    case YJCS_CONTRACT_ADD_ITEM:
      return {
        ...state,
        loading: true,
        addSuccess: false,
      };

    case YJCS_CONTRACT_ADD_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        yjcsContracts: payload,
        addSuccess: true,
      };
    case YJCS_CONTRACT_EDIT_ITEM:
      return {
        ...state,
        loading: true,
        editSuccess: false,
      };

    case YJCS_CONTRACT_EDIT_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        yjcsContracts: payload,
        editSuccess: true,
      };

    case YJCS_CONTRACT_DELETE_ITEM:
      return {
        ...state,
        loading: true,
      };
    case YJCS_CONTRACT_DELETE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        yjcsContracts: payload,
        deleteSuccess: true,
      };

    case YJCS_CONTRACT_GET_LIST_ERROR:
    case YJCS_CONTRACT_ADD_ITEM_ERROR:
    case YJCS_CONTRACT_EDIT_ITEM_ERROR:
    case YJCS_CONTRACT_DELETE_ITEM_ERROR:
    case YJCS_CONTRACT_GET_BY_ID_ERROR:
    case YJCS_CONTRACT_GET_BY_EMPLOYER_ERROR:
    case YJCS_CONTRACT_GET_BY_CLIENT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
